import { useCallback, useContext, useMemo, useState } from 'react';
import { useDefaultProject } from 'src/projects/hooks/useDefaultProject';
import { Link, useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
// import { PAGE_SIZE } from 'src/modules/common/constants.ts';
import { BELIMO_HASH_PREFIX } from 'src/BELIMO_HASH_PREFIX.ts';
import { Pagination } from 'src/modules/common/components/Pagination/Pagination.tsx';
import { usePageChange } from 'src/modules/common/hooks/usePageChange.ts';
import { Button } from 'src/modules/common/components/Button/Button.tsx';
import { RuntimeContext } from 'src/runtimeContext.ts';
import { Selection } from 'src/projects/types/Selection';
import { ConfigContext } from 'src/configContext';
import { CrossIcon } from 'src/modules/common/icons/CrossIcon';
import { PlusIcon } from 'src/modules/common/icons/PlusIcon';
import { I18n } from 'src/modules/common/components/I18n/I18n';
import { MESSAGES } from 'src/modules/common/constants';
import { Loading } from 'src/common/Loading/Loading';
import { ProjectEmptySelection } from 'src/projects/components/ProjectEmptySelection';
import { ProjectSelectionItem } from 'src/projects/components/ProjectSelectionItem';
import { ExportExcelButton } from 'src/projects/components/ExportExcelButton';
// import { useBelimoTranslate } from 'src/common/hooks/useBelimoTranslate';
// import { CartIcon } from 'src/modules/common/icons/CartIcon';
// import { prepareForCart } from 'src/projects/utils/prepareForCart';
// import { fetchDesignData } from 'src/common/fetchDesignData.ts';
// import { useApolloClient } from '@apollo/client';
// import { addToCart } from 'src/utils/addToCart.ts';

const limit = 10;
export const ProjectPage = () => {
    const { state: { selectionRepository, persistCallback }, loading } = useDefaultProject();
    const [
        inProgress,
        // setInProgress,
    ] = useState<boolean>(false);
    const count = selectionRepository.count();
    const { page } = useParams();
    const { isMobile } = useContext(RuntimeContext);
    const { userSettings } = useContext(ConfigContext);
    // const translate = useBelimoTranslate();
    // const apollo = useApolloClient();
    const [searchParams] = useSearchParams();
    const currentPage = useMemo(() => {
        const parsedPage = parseInt(page || '1', 10);
        return parsedPage < 1 ? 1 : parsedPage;
    }, [page]);
    const offset = (currentPage - 1) * limit;

    const [openedSelection, setOpenedSelection] = useState<string | null>(null);

    const navigate = useNavigate();
    const location = useLocation();

    const handleGoBack = () => {
        navigate({
            ...location,
            search: location.state === null ? '' : location.search,
            pathname:
                location.state === null
                    ? `${BELIMO_HASH_PREFIX}/`
                    : location.pathname.replace(/\/projects\/\d+/, ''),
        }, {
            state: location.state,
            replace: true,
        });
    };

    const onPageChange = usePageChange(
        (newPage: number) => location.pathname.replace(/\/projects\/\d+/, `/projects/${newPage}`),
        () => location.state,
    );

    const removeHandler = useCallback((selection: Selection) => {
        persistCallback(selectionRepository.remove(selection))
            .then(() => {
                if (selectionRepository.list(limit, offset).length === 0) {
                    const prevPage = currentPage - 1;
                    onPageChange(prevPage === 0 ? 1 : prevPage, searchParams);
                }
            })
        // @TODO handle errors
        // eslint-disable-next-line no-console
            .catch((err) => console.log(err));
    }, [currentPage, offset, onPageChange, persistCallback, searchParams, selectionRepository]);
    /*
    const checkoutHandler = useCallback(async () => {
        if (inProgress) {
            return;
        }
        try {
            setInProgress(true);
            const messages = await Promise.all(prepareForCart({
                selections: selectionRepository.list(selectionRepository.count(), 0),
                userSettings,
                translate,
            }).map(({ content, label, qty }) => {
                if (content === undefined) {
                    return Promise.resolve({ label, qty });
                }
                return fetchDesignData({
                    content,
                    apollo,
                }).then(({ result: designData }) => ({
                    label,
                    qty,
                    designData,
                }));
            }));
            addToCart(messages);
        } finally {
            setInProgress(false);
        }
    }, [apollo, inProgress, selectionRepository, translate, userSettings]); */

    if (inProgress) {
        return ('Adding to cart, please wait');
    }

    if (loading) {
        return (
            <div className="vss-project-page">
                <div className="vss-project-page__contents">
                    <div className="vss-project-page__header">
                        <div className="vss-project-page__title">
                            <I18n messageId={MESSAGES.projectPageTitle}/>
                        </div>
                    </div>

                    <div className="vss-project-page__loading">
                        <Loading/>
                    </div>
                </div>
            </div>
        );
    }

    if (count === 0) {
        return (
            <div className="vss-project-page">
                <div className="vss-project-page__contents">
                    <div className="vss-project-page__header">
                        <div className="vss-project-page__title">
                            <I18n messageId={MESSAGES.projectPageTitle}/>
                        </div>

                        <Button
                            kind="tertiary"
                            onClick={handleGoBack}
                            icon={(
                                <div className="vss-project-page__icon">
                                    <CrossIcon/>
                                </div>
                            )}
                        >
                            <I18n messageId={MESSAGES.projectPageGoBack}/>
                        </Button>
                    </div>

                    <ProjectEmptySelection/>
                </div>
            </div>
        );
    }

    return (
        <div className="vss-project-page">
            <div className="vss-project-page__contents">
                <div className="vss-project-page__header">
                    <div className="vss-project-page__title">
                        <I18n messageId={MESSAGES.projectPageTitle}/>
                    </div>

                    <Button
                        kind="tertiary"
                        onClick={handleGoBack}
                        icon={(
                            <div className="vss-project-page__icon">
                                <CrossIcon/>
                            </div>
                        )}
                    >
                        <I18n messageId={MESSAGES.projectPageGoBack}/>
                    </Button>
                </div>

                <div className="vss-project-page__actions">
                    <ExportExcelButton
                        selectionRepository={selectionRepository}
                        userSettings={userSettings}
                    />

                    {/* <Button
                        type="button"
                        onClick={checkoutHandler}
                    >
                        <I18n messageId={MESSAGES.checkout}/>

                        <div className="vss-project-page__icon">
                            <CartIcon/>
                        </div>
                    </Button> */}
                </div>

                <div className="vss-project-page__selections">
                    {selectionRepository
                        .list(limit, offset)
                        .map((selection) => (
                            <ProjectSelectionItem
                                key={selection.name}
                                selection={selection}
                                removeHandler={removeHandler}
                                openedSelection={openedSelection}
                                setOpenedSelection={setOpenedSelection}
                            />
                        ))}

                    <Pagination
                        total={count}
                        isMobile={isMobile}
                        currentPage={currentPage}
                        pageSize={limit}
                        onPageChange={(p) => onPageChange(p, searchParams)}
                    />

                    <div className="vss-project-page__actions">
                        <Button
                            kind="tertiary"
                            as={Link}
                            to={`${BELIMO_HASH_PREFIX}/`}
                            icon={(
                                <div className="vss-project-page__icon">
                                    <PlusIcon/>
                                </div>
                            )}
                        >
                            <I18n messageId={MESSAGES.projectPageAddNewSelection}/>
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};
